/* eslint-disable */
/**
 * Settings Module
 */
import { languages, sidebarFilters, routerAnimations, themes, headerFilters } from './data'

const state = {
  collapseSidebar: false, // mini sidevar
  horizontalLayoutSidebar: false, // horizontal layout sidebar
  languages, // languages
  selectedLocale: languages[0], // selected locale
  sidebarFilters, // sidebar filters
  sidebarSelectedFilter: sidebarFilters[0], // selected sidebar filter
  routerAnimations, // router animations
  selectedRouterAnimation: routerAnimations[0], // selected router animation
  themes, // themes
  selectedTheme: themes[0], // selected theme
  headerFilters, // header filters
  activeHeaderFilter: headerFilters[1], // selected header filter
  mobileSearchForm: false, // Is Mobile Search Form Open,
  toolbarHeight: 34,
  generalScrollStyle: 'height:calc(100vh - 155px)',
  app: null
}

// getters
const getters = {
  collapseSidebar: state => {
    return state.collapseSidebar
  },
  sidebarFilters: state => {
    return state.sidebarFilters
  },
  sidebarSelectedFilter: state => {
    return state.sidebarSelectedFilter
  },
  selectedRouterAnimation: state => {
    return state.selectedRouterAnimation
  },
  routerAnimations: state => {
    return state.routerAnimations
  },
  themes: state => {
    return state.themes
  },
  selectedTheme: state => {
    return state.selectedTheme
  },
  headerFilters: state => {
    return state.headerFilters
  },
  activeHeaderFilter: state => {
    return state.activeHeaderFilter
  },
  horizontalLayoutSidebar: state => {
    return state.horizontalLayoutSidebar
  },
  mobileSearchForm: state => {
    return state.mobileSearchForm
  },
  toolbarHeight: state => {
    return state.toolbarHeight
  },
  generalScrollStyle: state => {
    return state.generalScrollStyle
  },
  app: state => {
    return state.app
  }
}

// actions
const actions = {
  collapseSidebar(context) {
    context.commit('collapseSidebarHandler')
  },
  changeSidebarFilter(context, payload) {
    context.commit('changeSidebarFilterHandler', payload)
  },
  changeRouterAnimation(context, payload) {
    context.commit('changeRouterAnimationHandler', payload)
  },
  changeTheme(context, payload) {
    context.commit('changeThemeHandler', payload)
  },
  changeHeaderFilter(context, payload) {
    context.commit('changeHeaderFilterHandler', payload)
  },
  setMiniSidebarLayout(context, payload) {
    context.commit('setMiniSidebarLayoutHandler', payload)
  },
  toggleHorizontalLayoutSidebar(context, payload) {
    context.commit('toggleHorizontalLayoutSidebarHandler', payload)
  },
  toggleSearchForm(context) {
    context.commit('toggleSearchFormHandler')
  },
  setApp(context,payload) {
    context.commit('setApp',payload)
  }
}

// mutations
const mutations = {
  collapseSidebarHandler(state) {
    state.collapseSidebar = !state.collapseSidebar
  },
  changeSidebarFilterHandler(state, filter) {
    state.sidebarSelectedFilter = filter
  },
  changeRouterAnimationHandler(state, animation) {
    state.selectedRouterAnimation = animation
  },
  changeThemeHandler(state, theme) {
    state.selectedTheme = theme
  },
  changeHeaderFilterHandler(state, filter) {
    state.activeHeaderFilter = filter
  },
  setMiniSidebarLayoutHandler(state, isSet) {
    state.collapseSidebar = isSet
  },
  toggleHorizontalLayoutSidebarHandler(state, value) {
    state.horizontalLayoutSidebar = value
  },
  toggleSearchFormHandler(state) {
    state.mobileSearchForm = !state.mobileSearchForm
  },
  setApp(state, value) {
    state.app = value.config
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
